<template>
  <v-row v-if="showOverlay" justify="center">
    <v-col cols="12">
      <v-row align="center">
        <v-overlay
          v-if="shouldShowOverlay"
          :absolute="false"
          :opacity="0.8"
          :value="showOverlay"
        >
          <a
            href="#"
            v-click-outside="onClickOutside"
            style="width: 440px; height: 248px; display: block"
          >
            <vue-vimeo-player
              :options="{
                responsive: true,
                width: 440,
                height: 248,
                autoplay: true,
                pip: true,
                speed: true,
              }"
              :autoplay="true"
              :speed="true"
              ref="checkout"
              :video-url="this.checkoutVideoUrl"
            />
          </a>
        </v-overlay>
      </v-row>
    </v-col>
  </v-row>
</template>

<script>
import Lottie from "vue-lottie";
import * as animationData from "../../../../animations/433-checked-done.json";
import { vueVimeoPlayer } from "vue-vimeo-player";

export default {
  components: {
    lottie: Lottie,
    vueVimeoPlayer,
  },
  props: {
    message: { type: String },
    path: { type: String },
    showOverlay: { type: Boolean },
    checkoutVideoUrl: { type: String },
  },
  data() {
    return {
      defaultOptions: {
        animationData: animationData.default,
        loop: false,
        autoplay: true,
        rendererSettings: { preserveAspectRatio: "xMidYMid slice" },
      },
      animationSpeed: 0.6,
      anim: null,
    };
  },
  methods: {
    handleAnimation: function (anim) {
      this.anim = anim;
      this.anim.setSpeed(this.animationSpeed);
    },
    onClickOutside() {
      this.showOverlay = false;
    },
  },
  computed: {
    shouldShowOverlay() {
      return !!this.checkoutVideoUrl;
    },
  },
};
</script>

<style scoped></style>
